import { DateTime } from "luxon";
import { z } from "zod";
const creditTypes = ["ai_credits", "voice_credits"];
const creditTypeSchema = z.enum(creditTypes);
const USAGE_ALERT_THRESHOLD_PERCENT = 90;
const AiCreditBalanceLevel = {
  Available: "available",
  RunningLow: "running_low",
  Exhausted: "exhausted"
};
function resolveAiCreditBalance(period, now) {
  const { balances } = period;
  switch (balances.kind) {
    case "live": {
      if (balances.remaining_credits === 0) {
        return { level: AiCreditBalanceLevel.Exhausted };
      }
      const coveredCredits = period.credits_used - period.credits_overage;
      const usedShare = coveredCredits / (coveredCredits + balances.remaining_credits);
      const startsAt = DateTime.fromISO(period.starts_at);
      const elapsedShare = now.diff(startsAt).toMillis() / DateTime.fromISO(period.ends_at).diff(startsAt).toMillis();
      const percentUsed = Math.floor(usedShare * 100);
      if (percentUsed >= USAGE_ALERT_THRESHOLD_PERCENT && usedShare > elapsedShare) {
        return {
          level: AiCreditBalanceLevel.RunningLow,
          percent_used: percentUsed
        };
      }
      return { level: AiCreditBalanceLevel.Available };
    }
    case "at_period_close":
    case "unknown":
      return period.credits_overage > 0 ? { level: AiCreditBalanceLevel.Exhausted } : { level: AiCreditBalanceLevel.Available };
  }
}
export {
  AiCreditBalanceLevel,
  USAGE_ALERT_THRESHOLD_PERCENT,
  creditTypeSchema,
  creditTypes,
  resolveAiCreditBalance
};
//# sourceMappingURL=creditUsage.js.map
